import * as React from 'react';
import {useEffect, useState} from "react";
import {Community} from "../community/queries/community";
import {Container, Stack, Typography, Box, Breadcrumbs, IconButton, Button} from '@mui/material';
import CommunityCard from "../community/CommunityCard";
import Slider from "react-slick";
import {useDarkMode} from "../darkMode/hook/useDarkMode";
import {withServiceListContext} from "../service/state/serviceContext";
import ServiceItemPlaceholder from "../service/ServiceItemPlaceholder";
import {useNavigate} from "react-router-dom";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import {useSubmit} from "../marketPlace/hooks/useSubmit";
import ServiceItemUser from "../service/ServiceItemUser";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";



const Favorite = ({setShowNav}) => {
    const navigate = useNavigate();
    const [communities, setCommunities] = useState([]);
    // const {isLoading, services} = useServiceList();
    const [isLoadingCommunities, setIsLoadingCommunities] = useState(false);
    const {mode} = useDarkMode();
    const [showMoveUpButton, setShowMoveUpButton] = useState(false);
    const [showMoveDownButton, setShowMoveDownButton] = useState(true);
    const [anchor, setAnchor] = useState(0);
    const {searchProduct} = useSubmit();
    const [services, setServices] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [seeAll, setSeeAll] = useState(false);

    const getService = async () => {
        setIsLoading(true);
        return await searchProduct('');
    }

    useEffect(() => {
        setShowNav(true);
    }, [])

    useEffect(async() => {
        const ser = await getService();
        console.log('ser:', ser);
        setServices(ser.filter(item => item.favorite == true && item.category !== 'racine' && item.category !== 'accueil'));
        setIsLoading(false);
    }, []);

    useEffect(() => {
        setIsLoadingCommunities(true);
        Community.getCommunities().then((res) => {
            setIsLoadingCommunities(false);
            setCommunities(res.filter(community => community.favorite == true));
        })
    },[]);

    const handleClick = () => {
        setSeeAll(current => !current);
    };

    const moveUp = () => {
        const tempPosition = anchor - 1;
        const tempAnchor = 'anchor'+tempPosition;
        const anchorEl = document.getElementById(tempAnchor);
        if (anchorEl) {
            window.scrollTo({
                top: anchorEl.offsetTop - process.env.REACT_APP_HEADER_HEIGHT,
                behavior: "smooth",
            });
            setAnchor(anchor - 1);
        }
        const nextPosition = tempPosition - 1;
        if (document.getElementById('anchor'+nextPosition) == null) {
            setShowMoveUpButton(false);
            setShowMoveDownButton(true);
        } else {
            setShowMoveUpButton(true);
            setShowMoveDownButton(true);
        }
    };

    const moveDown = () => {
        const tempPosition = anchor + 1;
        const tempAnchor = 'anchor'+tempPosition;
        const anchorEl = document.getElementById(tempAnchor);
        if (anchorEl) {
            window.scrollTo({
                top: anchorEl.offsetTop - process.env.REACT_APP_HEADER_HEIGHT,
                behavior: "smooth",
            });
            setAnchor(anchor + 1);
        }
        const nextPosition = tempPosition + 1;
        if (document.getElementById('anchor'+nextPosition) == null) {
            setShowMoveDownButton(false);
            setShowMoveUpButton(true);
        } else {
            setShowMoveDownButton(true);
            setShowMoveUpButton(true);
        }

    };

    const settingsCommunities = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: communities.length < 3 ? communities.length : 3,
        adaptiveHeight : true,
        centerPadding: '-15px',
        centerMode: true,
        responsive: [
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 1,
                    variableWidth : false,
                    arrows : false,
                    centerPadding: '0px',
                },
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                    variableWidth : false,
                    centerPadding: '0px',
                },
            }
        ],
        variableWidth : false
    };

    const settingsServices = {
        dots: false,
        infinite: true,
        speed: 500,
        centerPadding: '-15px',
        centerMode: true,
        slidesToShow: services.filter((service) => service.isFavorite == true).length < 3 ? services.filter((service) => service.isFavorite == true).length: 3,
        responsive: [
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 1,
                    variableWidth : false,
                    arrows : false,
                    centerPadding: '0px',
                },
            },
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 2,
                    variableWidth : false,
                    centerPadding: '0px',
                },
            }
        ],
        variableWidth : true
    };
    console.log(services, services.length)

    const breadcrumbs = [
        <Typography
            className={'breadcrumbs'}
            variant={'body2'}
            onClick={() => navigate('/')}
            style={{color: mode.settings.breadcrumbColor1}}>
            Accueil
        </Typography>,
        <Typography variant={'body2'} style={{color: mode.settings.textColor3}}>
            Favoris
        </Typography>,
    ];


    return (
        <div style={{display: 'flex'}}>
            <Container className={'container'} sx={{marginTop: '17px'}}>
                <Breadcrumbs
                    separator="›"
                    aria-label="navigation"
                    style={{color: mode.settings.textColor3}}>
                    {breadcrumbs}
                </Breadcrumbs>
                <Stack direction={"column"} sx={{marginTop: '17px'}}>
                    <Box>
                        <Typography
                            variant='h5'
                            sx={{
                                color : mode.settings.textColor3,
                                textAlign : {xs : 'center' , md : 'center', lg : 'left'},
                                mb: {xs : 4 , md : 4, lg : 2}
                            }}
                            id={'anchor0'}
                        > Communautés
                        </Typography>
                        {
                        !seeAll ?
                            !isLoadingCommunities ?
                                communities.length > 2 ?
                                    <Stack>
                                        <Slider {...settingsCommunities}>
                                            {communities.map((community, index) => (
                                                <div key={index}>
                                                    <CommunityCard community={community}
                                                                   sx={{
                                                                       width: {xs: '360px', md: '380px', lg: '380px'},
                                                                       ml: {
                                                                           xs: 'auto !important',
                                                                           md: 'auto !important',
                                                                           lg: '0px !important'
                                                                       },
                                                                       mr: {
                                                                           xs: 'auto !important',
                                                                           md: 'auto !important',
                                                                           lg: '0px !important'
                                                                       },
                                                                   }}
                                                                   member={true}
                                                    />
                                                </div>
                                            ))
                                            }
                                        </Slider>
                                        <Stack style={{width: '100%'}} direction={'row'} justifyContent={'center'}
                                               sx={{
                                                   mb: {xs: 4, md: 4, lg: 2},
                                                   mt: {xs: 4, md: 4, lg: 2},
                                               }}
                                        >
                                            <Button
                                                className="btn-gradient"
                                                style={{width : '325px'}}
                                                startIcon={
                                                    <RemoveRedEyeIcon
                                                        role="img"
                                                        aria-label={'Voir tout'}
                                                    />
                                                }
                                                onClick={handleClick}>
                                                <Typography variant={'subtitle3'}>
                                                    Voir tout
                                                </Typography>
                                            </Button>
                                        </Stack>
                                    </Stack>
                                         :
                                        <Stack direction={'row'} gap={'34px'}>
                                            {communities.map((community, index) => (
                                                <div key={index}>
                                                    <CommunityCard community={community}
                                                                   sx={{
                                                                       width: {xs: '360px', md: '380px', lg: '380px'},
                                                                       ml: {
                                                                           xs: 'auto !important',
                                                                           md: 'auto !important',
                                                                           lg: '0px !important'
                                                                       },
                                                                       mr: {
                                                                           xs: 'auto !important',
                                                                           md: 'auto !important',
                                                                           lg: '0px !important'
                                                                       },
                                                                   }}
                                                                   member={true}
                                                    />
                                                </div>
                                            ))}

                                        </Stack>
                                :
                                <Stack direction={'row'} spacing={2} sx={{mb: 1, marginTop: 2}}>
                                    {Array(3)
                                        .fill('')
                                        .map(() => (
                                            <ServiceItemPlaceholder />
                                        ))}
                                </Stack>
                            :
                            <Stack>
                                <Stack direction={'row'} gap={'32px'} flexWrap={"wrap"}>
                                    {communities.map((community, index) => (
                                        <div key={index}>
                                            <CommunityCard community={community}
                                                           sx={{
                                                               width: {xs: '360px', md: '380px', lg: '380px'},
                                                               ml: {
                                                                   xs: 'auto !important',
                                                                   md: 'auto !important',
                                                                   lg: '0px !important'
                                                               },
                                                               mr: {
                                                                   xs: 'auto !important',
                                                                   md: 'auto !important',
                                                                   lg: '0px !important'
                                                               },
                                                           }}
                                                           member={true}
                                            />
                                        </div>
                                    ))}
                                </Stack>
                                <div className={'div-btn-center'}>
                                    <Button
                                        className="btn-gradient"
                                        startIcon={
                                            <RemoveRedEyeIcon
                                                role="img"
                                                aria-label={'Voir moins de communauté'}
                                            />
                                        }
                                        onClick={handleClick}>
                                        Voir moins
                                    </Button>
                                </div>
                            </Stack>

                        }
                    </Box>

                    <Box>
                        <Typography
                            variant="h5"
                            sx={{
                                mt: {xs : 2 , md : 2, lg : 2},
                                mb: {xs : 4 , md : 4, lg : 2},
                                textAlign : {xs : 'center' , md : 'center', lg : 'left'},
                            }}
                            style={{color: mode.settings.textColor3}}
                            id={'anchor1'}
                        >
                            Mes services et conseils
                        </Typography>
                        <Stack direction={"row"} justifyContent={"flex-start"} flexWrap={"wrap"} spacing={'50px'}>
                            {services && !isLoading && services.slice(0,3).map((product, index) =>
                                <ServiceItemUser
                                    id={product.id}
                                    title={product.name}
                                    description={product.description}
                                    variant={product.category}
                                    image={product.image}
                                    variantName={product.category}
                                    controls={['show-detail','marketplace','add-to-fav']}
                                    treading={false}
                                    treadingBadge={false}
                                    isFavorite={product.favorite}
                                    addMargin={true}
                                    key={index}
                                    wishlistId={product.wishlistId}
                                    wishListProductId={product.wishListIdProduct}
                                />
                            )}
                        </Stack>
                    </Box>
                </Stack>
                {
                    showMoveUpButton ?
                        <Box sx={{position: 'fixed', right: 0, top: '25%'}}>
                            <IconButton
                                className={'btn-gradient'}
                                sx={{
                                    color: '#FFFFFF',
                                    borderRadius: 0,
                                    borderTopLeftRadius: '10%',
                                    borderBottomLeftRadius: '10%'
                                }}
                                onClick={moveUp}
                            >
                                <ArrowUpwardIcon role="img" aria-label={"Remonter au bloc précédent"}/>
                            </IconButton>
                        </Box> : <div></div>
                }
                {
                    showMoveDownButton ?
                        <Box sx={{position: 'fixed', right: 0, top: '32%'}}>
                            <IconButton
                                className={'btn-gradient'}
                                sx={{
                                    color: '#FFFFFF',
                                    borderRadius: 0,
                                    borderTopLeftRadius: '10%',
                                    borderBottomLeftRadius: '10%'
                                }}
                                onClick={moveDown}
                            >
                                <ArrowDownwardIcon role="img" aria-label={"Descendre au prochain bloc"}/>
                            </IconButton>
                        </Box>: <div></div>
                }
            </Container>
        </div>

    )
}

export default withServiceListContext(Favorite);
